export default __webpack_public_path__ + "static/media/coinforbarter.ddd679cb.png";